import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import StatusBadge from '../common/StatusBadge';
import Alert from '../common/Alert';
import IdentityCheck from './IdentityCheck';
import IncomeCheck from './IncomeCheck';
import AffordabilityCalc from './AffordabilityCalc';
import CreditCheck from './CreditCheck';
import ManualReview from './ManualReview';
import { CHECK_TYPES, VERIFICATION_STATUSES } from '../../utils/constants';
import './VerificationTask.css';

const VerificationTask = () => {
  const { taskId } = useParams();
  const navigate = useNavigate();
  const [showManualReview, setShowManualReview] = useState(false);

  // Mock Task Data
  const task = {
    id: taskId,
    type: CHECK_TYPES.INCOME, // Mocking income check for demo
    status: VERIFICATION_STATUSES.ATTENTION_REQUIRED,
    application: { id: 'APP-001', applicantName: 'John Doe', property: '123 Main St', date: '2023-10-25' },
    consentValid: true,
    assignedTo: 'Current User',
    evidence: [{ id: 'doc1', name: 'Bank_Statement.pdf' }]
  };

  const renderCheckComponent = () => {
    switch (task.type) {
      case CHECK_TYPES.IDENTITY: return <IdentityCheck task={task} />;
      case CHECK_TYPES.INCOME: return <IncomeCheck task={task} />;
      case CHECK_TYPES.AFFORDABILITY: return <AffordabilityCalc task={task} />;
      case CHECK_TYPES.CREDIT: return <CreditCheck task={task} />;
      default: return <div>Check type component pending...</div>;
    }
  };

  return (
    <div className="verification-task">
      <div className="task-header card">
        <div className="card-body">
          <div className="task-header__top">
            <div className="task-title-group">
              <button className="btn-back" onClick={() => navigate('/verification')}>&larr; Back</button>
              <h1 className="task-title">{task.type.replace('_', ' ').toUpperCase()} CHECK</h1>
              <StatusBadge status={task.status} />
            </div>
            <div className="task-assignee">
              Assigned to: <strong>{task.assignedTo || 'Unassigned'}</strong>
            </div>
          </div>
          
          <div className="task-context">
            <div className="context-item">
              <span className="label">Applicant:</span> {task.application.applicantName}
            </div>
            <div className="context-item">
              <span className="label">Property:</span> {task.application.property}
            </div>
            <div className="context-item">
              <span className="label">Valid Consent:</span> 
              {task.consentValid ? <span className="success-text">Confirmed</span> : <span className="danger-text">Missing</span>}
            </div>
          </div>
        </div>
      </div>

      {!task.consentValid && (
        <Alert type="error" message="Valid consent is missing for this check. Do not proceed until consent is verified." />
      )}

      {showManualReview ? (
        <ManualReview task={task} onCancel={() => setShowManualReview(false)} onComplete={() => navigate('/verification')} />
      ) : (
        <div className="task-content">
          <div className="check-workspace">
            {renderCheckComponent()}
          </div>
          
          <div className="task-sidebar">
            <div className="card">
              <div className="card-header"><h3>Actions</h3></div>
              <div className="card-body task-actions">
                <button className="btn-primary" onClick={() => setShowManualReview(true)}>
                  Manual Review & Decision
                </button>
                <p className="helper-text" style={{marginTop: '16px'}}>
                  Automated adverse decisions are disabled. Please use manual review to log negative results or flag for attention.
                </p>
              </div>
            </div>

            <div className="card">
              <div className="card-header"><h3>Evidence</h3></div>
              <div className="card-body">
                <ul className="evidence-list">
                  {task.evidence.map(doc => (
                    <li key={doc.id}><a href="#">{doc.name}</a></li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default VerificationTask;
